'use client';

import type { ComponentProps } from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';

/**
 * Give fixed-position tooltips a measurable containing block so Floating UI
 * accounts for the responsive CSS zoom on <html>. The full-screen wrapper
 * ignores pointer events; only the tooltip itself can receive them.
 */
const TooltipPortal = ({ children, ...props }: ComponentProps<typeof Tooltip.Portal>) => (
  <Tooltip.Portal {...props}>
    <div className="fixed inset-0 z-50 pointer-events-none [contain:layout] [&>*]:pointer-events-auto">{children}</div>
  </Tooltip.Portal>
);

export default TooltipPortal;
